export const HOURLY = 1
export const MONTHLY = 2
export const ANNUAL = 3
